import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import * as reportActions from '../store/actions';
import { ModelResponse } from '../../core/services/ModelResponse';
import { ReportService } from './ReportService';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ReportCategoryModel } from '../models/ReportCategoryModel';
import { ActionError } from '../../pillar/common/actions/ActionError';
import { ResponseMessage } from '../../core/services/ResponseMessage';
import { ResponseMessageType } from '../../core/services/ResponseMessageType';
import { HttpErrorResponse } from '@angular/common/http';
import { SsrsConfigModel } from '../models/SsrsConfigModel';
import { ActionBase } from '../../core/store/action/ActionBase';

@Injectable()
export class ReportServiceEffects {
  @Effect()
  getSsrsReportsList$: Observable<Action> = this.actions$.ofType(reportActions.GET_REPORTS_QUERY)
      .switchMap((a: reportActions.GetReportsQueryAction) => this.reportService.getSsrsReportsList(a.payload.page, a.payload.pageSize, a.payload.sort, a.payload.sortDirection, a.payload.searchTerm)
        .catch((error: HttpErrorResponse) => {
        var response = new QueryResponse<ReportCategoryModel>();
        response.hasError = true;
        var responseMessage = new ResponseMessage();
        responseMessage.type = ResponseMessageType.Error;
        responseMessage.value = error.message;
        response.messages = [responseMessage];
        return Observable.of(response);
      })
      .map((response: QueryResponse<ReportCategoryModel>) => {
          if (response.hasError) {
            return new ActionError(a, response.messages.map(m => m.value));
          }
          return new reportActions.GetReportsQuerySuccessAction({ items: response.items });
      }));
  @Effect()
  getCurrentUserPermissions$: Observable<Action> = this.actions$.ofType(reportActions.GET_SSRS_CONFIG)
    .switchMap((a: ActionBase) => this.reportService.getSsrsConfig()
      .catch((error: HttpErrorResponse) => {
        var response = new ModelResponse<SsrsConfigModel>();
        response.hasError = true;
        var responseMessage = new ResponseMessage();
        responseMessage.type = ResponseMessageType.Error;
        responseMessage.value = error.message;
        response.messages = [responseMessage];
        return Observable.of(response);
      })
      .map((response: ModelResponse<SsrsConfigModel>) => {
        if (response.hasError) {
          return new ActionError(a, response.messages.map(m => m.value));
        }
        return new reportActions.GetSsrsConfigSuccessAction(response.model);
      }));

  constructor(
    private reportService: ReportService,
    private actions$: Actions
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/report/services/ReportService.effects.ts